<!-- 机构-订单管理 -->
<template>
  <div>
    <div class="index">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
        <div class="Homeboxtop_nav_tab">
          <span
            v-for="(item, index) in tabList"
            :class="['res-tab', { active: item.name === tabName }]"
            :key="index"
            @click="tabClick(item)"
          >
            {{ item.name }}
          </span>
        </div>
      </div>

      <div>
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <!-- <el-form-item label="">
            <el-input
              v-if="tabName === '缴费'"
              v-model="queryParams.orderNo"
              placeholder="请输入订单编号"
            ></el-input>
            <el-input
              v-else
              v-model="queryParams_2.orderNo"
              placeholder="请输入订单编号"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="">
            <el-input
              v-if="tabName === '缴费'"
              v-model="queryParams.name"
              placeholder="请输入课程名称"
            ></el-input>
            <el-input
              v-else
              v-model="queryParams_2.name"
              placeholder="请输入课程名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="" v-if="tabName === '缴费'">
            <el-select
              v-model="queryParams.status"
              clearable
              placeholder="订单状态"
              class="label"
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <!-- 缴费 -->
            <el-date-picker
              v-if="tabName === '缴费'"
              v-model="queryParams.date"
              type="daterange"
              style="width: 240px"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
            <!-- 退费 -->
            <el-date-picker
              v-else
              v-model="queryParams_2.date"
              type="daterange"
              style="width: 240px"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>

        <!-- 缴费 -->
        <div class="table" v-if="tabName === '缴费'">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              prop="orderNo"
              label="订单编号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="cname"
              label="课程"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="buyerName"
              label="学生姓名"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="schoolName"
              label="学校"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="报名时间"
              width="180px"
              align="center"
            >
              <template slot-scope="scope">
                {{  dayjs(scope.row.createTime).format("YYYY.MM.DD HH:mm")}}
              </template>
            </el-table-column>
            <el-table-column prop="amountTotal" label="已缴费用" align="center">
              <template slot-scope="scope">
                {{ scope.row.amountTotal/100 || 0 }}
              </template>
            </el-table-column>
            <el-table-column label="订单状态" align="center">
              <template slot-scope="scope">
                {{ scope.row.status | statusFilter }}
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="queryParams.pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="queryParams.pageSize"
              :total="queryParams.totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>

        <!-- 退费 -->
        <div class="table" v-if="tabName === '退费'">
          <el-table :data="tableData1" style="width: 100%">
            <el-table-column
              prop="orderNo"
              label="订单编号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="cname"
              label="课程"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="buyerName"
              label="学生姓名"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column prop="applyReason" label="退款原因" align="center">
              <template slot-scope="scope">
                {{ scope.row.applyReason | refundFilter }}
              </template>
            </el-table-column>
            <el-table-column
              prop="applyTime"
              label="申请退款时间"
              width="150px"
              align="center"
            >
              <template slot-scope="scope">
                {{  dayjs(scope.row.applyTime).format("YYYY.MM.DD hh:mm")}}
              </template>
            </el-table-column>
            <el-table-column prop="amountPayerRefund" label="退款金额" align="center">
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="queryParams_2.pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="queryParams_2.pageSize"
              :total="queryParams_2.totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mechanismApi from "@/api/mechanismApi/curriculum.js";
import dayjs from "dayjs";
export default {
  components: {},
  data() {
    return {
      queryParams: {
        status: "",
        orderNo: "",
        date: "",
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      queryParams_2: {
        status: "",
        orderNo: "",
        date: "",
        pageNum: 1,
        pageSize: 10,
        totalPage:0,
      },
      statusList: [
        { value:'UNPAID',label:'待支付' },
				{ value:'PAYED',label:'已支付' },
				{ value:'REVOKE',label:'已关闭' },
				{ value:'CLOSED',label:'已完成' },
      ],
      tabList: [{ name: "缴费" }, { name: "退费" }],
      stateList: [], // 状态列表
      tableData: [],
      tableData1: [],
      tabName: "缴费",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  watch: {
    tabName: function (n, o) {
      this.getDataList();
    },
  },
  created() {
    this.getDataList();
  },
  filters: {
    statusFilter(type) {
      const typeMap = {
        'UNPAID': "待支付",
				'PAYED': "已支付",
				'REVOKE': "已关闭",
				'CLOSED': "已完成",
      };
      return typeMap[type] || "无";
    },
    refundFilter(type){
      const typeMap = {
        'UNWANTED': '拍错/拍多/不想要',
        'BREACH_STARTED': '未按约定时间开课',
        'BREACH_TEACHERS': '师资条件不符',
        'BREACH_CONTENT': '课程虚假宣传',
        'PERSONAL': '学员自身问题',
      };
      return typeMap[type] || "无";
    },
  },
  methods: {
    dayjs,
    async getDataList() {
		  let _this = {}, api='handleEnterpriseList';
      if(this.tabName==='缴费'){
				_this = this.queryParams;
        api='handleEnterpriseList';
			}else{
				_this = this.queryParams_2;
        api='getOrderEnterpriseRefunds';
			}
      let startTime = "",
        endTime = "";
      if (_this.date) {
        startTime = dayjs(_this.date[0]).format("YYYY-MM-DD");
        endTime = dayjs(_this.date[1]).format("YYYY-MM-DD");
      }
      let params = {
        pageNum: _this.pageNum,
        pageSize: _this.pageSize,
        startTime: startTime,
        endTime: endTime,
        type: _this.status, //查询类型(枚举值): PAYED.支付完成 UNPAID.待支付，REVOKE.交易关闭, REFUND.退款中, REFUNDED.已退
        orderNo: _this.orderNo,
        cname:_this.name,
      };
      for (var key in params) {
        if (params[key] == "") {
          delete params[key];
        }
      }
	    let { result, data } = await mechanismApi[api](params);
      if (result === "000000") {
        if(this.tabName==='缴费'){
          this.tableData = data.list;
        }else{
          this.tableData1 = data.list;
        }
        _this.totalPage = data.total;
      }
    },
    searchFun() {
      if(this.tabName==='缴费'){
        this.queryParams.pageNum = 1;
      }else{
        this.queryParams_2.pageNum = 1;
      }
      this.getDataList();
    },
    sizeChangeHandle(val) {
      if(this.tabName==='缴费'){
        this.queryParams.pageSize = val;
      }else{
        this.queryParams_2.pageSize = val;
      }
      this.getDataList();
    },
    currentChangeHandle(val) {
      if(this.tabName==='缴费'){
        this.queryParams.pageNum = val;
      }else{
        this.queryParams_2.pageNum = val;
      }
      this.getDataList();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    tabClick(item) {
      this.tabName = item.name;
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
